import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

import {
  CountryCodes,
  CountryPhoneCodes,
  DefaultMaskPattern,
  FinlandValidPhoneNumberLength,
  LatviaValidPhoneNumberLength,
  ValidPhoneNumberLength_10,
} from '@shared/constants/country-phone-codes.const';

@Injectable({
  providedIn: 'root',
})
export class PhoneValidatorService {
  sortedCountryCodes = [...CountryCodes].sort((a, b) => b.displayValue.length - a.displayValue.length);

  parsePhoneNumber(value: string, returnDefaultCode = true): { phoneCode: number; phoneNumber: string } {
    let phoneCode = returnDefaultCode ? 1 : null;
    let phoneNumber = null;
    if (!value) return { phoneCode, phoneNumber };

    const matched = this.sortedCountryCodes.find(country => value.startsWith(country.displayValue));
    if (matched && value) {
      phoneCode = matched.value;
      phoneNumber = value.slice(`${phoneCode}`.length + 1);
    }
    return { phoneCode, phoneNumber };
  }

  onGetMaskPattern(phoneCode: number): { maskPattern: string; validPhoneNumberLength: number } {
    let maskPattern = DefaultMaskPattern;
    let validPhoneNumberLength = ValidPhoneNumberLength_10;
    if (phoneCode === CountryPhoneCodes.Latvia) {
      maskPattern = '(000) 000-00';
      validPhoneNumberLength = LatviaValidPhoneNumberLength;
    } else if (phoneCode === CountryPhoneCodes.Finland) {
      maskPattern = '(000) 000-000';
      validPhoneNumberLength = FinlandValidPhoneNumberLength;
    } else if (phoneCode === CountryPhoneCodes.Russia) {
      maskPattern = '000 000 00 00';
      validPhoneNumberLength = ValidPhoneNumberLength_10;
    } else if (phoneCode === CountryPhoneCodes.Mexico) {
      maskPattern = '(00) 00 00 00 00';
      validPhoneNumberLength = ValidPhoneNumberLength_10;
    }
    return { maskPattern, validPhoneNumberLength };
  }

  phoneNumberValidator = (skipValidation = false): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
      if (!control.value || skipValidation) {
        return null;
      }

      const { phoneCode, phoneNumber } = this.parsePhoneNumber(control.value);
      const { validPhoneNumberLength } = this.onGetMaskPattern(phoneCode);

      return phoneNumber && phoneCode && phoneNumber.length === validPhoneNumberLength ? null : { phoneNumber: true };
    };
  };
}
